import { getConfig } from '../config';

export interface RunInfluencerCommissionRequest {
  /** Testing only: confirm commission this many days after completion. The API ignores it on production. */
  holdDays?: number;
}

export interface RunInfluencerCommissionResult {
  recorded: number;
  recomputed: number;
  confirmed: number;
  settledCreators: number;
  skipped: number;
}

/**
 * The affiliate commission batch (record → confirm → roll into the wallet) normally runs on a schedule;
 * the admin can also kick it off by hand, for example right after completing a test order.
 */
export class InfluencerCommissionClient {
  constructor(private readonly apiUrl: string) {}

  async run(request: RunInfluencerCommissionRequest = {}): Promise<RunInfluencerCommissionResult> {
    const body = request.holdDays === undefined ? {} : { holdDays: request.holdDays };
    const response = await fetch(`${this.apiUrl}/influencer/commission/process`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': getConfig().apiKey,
      },
      body: JSON.stringify(body),
    });

    if (!response.ok) {
      throw new Error(`Failed to run the commission batch: ${await this.describeFailure(response)}`);
    }

    return await response.json();
  }

  private async describeFailure(response: Response): Promise<string> {
    try {
      const payload = await response.json();
      const message = Array.isArray(payload?.message) ? payload.message.join(', ') : payload?.message;
      return message ? `${response.status} ${message}` : response.statusText;
    } catch {
      return response.statusText;
    }
  }
}
